var map = {
	"./01-afghanistan-energy-security.jpg": "6048",
	"./02-the-greenest-kind.jpg": "be10",
	"./03-revisit-our-regional-conference.jpg": "0fb8",
	"./04-revisit-our-web-discussions.jpg": "c7f6",
	"./05-the-new-normal.jpg": "f3f6",
	"./06-fes-contributes.jpg": "2b0f",
	"./07-transforming-cities-for-decent.jpg": "fa75",
	"./08-the-pathway-to-a-socially.png": "3e44",
	"./09-the-social-city-enabling.png": "7c3a",
	"./10-alliances-for-gender-just.png": "17b1",
	"./11-social-ecological-transformation-in.png": "266a",
	"./12-who-gets-to-stay.jpg": "7349",
	"./13-a-socially-just-energy.jpg": "ca27",
	"./14-getting-there.png": "5401",
	"./15-building-liveable-social.jpg": "87d2",
	"./16-women-and-climate.jpg": "4a75",
	"./17-climate-conscious-urbanisation.jpg": "9987",
	"./18-could-citys-health.png": "58e6",
	"./19-towards-a-socially-just.jpg": "0468",
	"./20-building-alliances.jpg": "5dfd",
	"./21-the-case-for-social-cities.jpg": "8898",
	"./22-the-social-city-aspiration.jpg": "0859",
	"./23-op-ed-asian-development.jpg": "e76e",
	"./24-linking-the-global-urban.jpg": "9637",
	"./25-building-a-low-carbon.jpg": "0d34",
	"./26-further-steps-are-needed.jpg": "6b82",
	"./27-promoting-socially.jpg": "f9b8",
	"./28-social-urban-policy.jpg": "9552",
	"./29-crossing-over-the-energy.png": "1f01",
	"./30-how-to-put-the-social.jpg": "a8cc",
	"./31-achieving-a-socially-equitable.jpg": "d16f",
	"./32-pathways-towards-a-social-ecological-transformation-in-asian-cities.png": "2e89",
	"./Chennai.png": "5f17",
	"./Manila Mobility Cover_Page_01.png": "0e88",
	"./Metro Manila.jpg": "ea74",
	"./Summary_mobility_studies_frontcover.jpg": "79f0",
	"./placeholder.png": "bc97",
	"./thumbnail/pathway-towards-set-in-asian-cities-infographic.png": "b98a",
	"./thumbnail/set-conference-day1-infographic.png": "9c32",
	"./thumbnail/set-conference-day2-infographic.png": "fb11",
	"./thumbnail/set-conference-day3-infographic.png": "9636"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8f6c";